/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class GCSBucket {
  /**
  * The name of the bucket
  */
  'bucketName': string;
  /**
  * The location of the bucket
  */
  'location': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "bucketName",
      "baseName": "bucketName",
      "type": "string",
      "format": ""
    },
    {
      "name": "location",
      "baseName": "location",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GCSBucket.attributeTypeMap;
  }

  public constructor() {
  }
}

